var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: { id: "cp", title: "Додати до чорного списку", centered: "" },
          on: { shown: _vm.focusMyElement },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _c(
                    "b-button",
                    {
                      ref: "SaveBt",
                      attrs: { variant: "success" },
                      on: { click: _vm.add },
                    },
                    [_vm._v("Додати\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.modalShow = false
                        },
                      },
                    },
                    [_vm._v("Закрити\n            ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.modalShow,
            callback: function ($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow",
          },
        },
        [
          _c("b-form-input", {
            ref: "focusThis",
            attrs: {
              maxlength: "10",
              placeholder: "Вкажіть ЄДРПОУ",
              pattern: "[0-9]",
            },
            on: {
              keypress: function ($event) {
                return _vm.isNumber($event)
              },
            },
            model: {
              value: _vm.edrpou,
              callback: function ($$v) {
                _vm.edrpou = $$v
              },
              expression: "edrpou",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }